import { useRouter } from 'next/router';
import { getPublicRuntimeConfig } from '../../../libs/init/getPublicRuntimeConfig';

export function useIsPageAppletRoute(): boolean {
  const { pathname } = useRouter();
  const { paths } = getPublicRuntimeConfig();

  return pathname === paths.extensionsPageAppletProvider;
}
